import { useEffect, VoidFunctionComponent } from 'react';
import { useAccount } from 'wagmi';
import { Text } from '@react-three/drei';
import { Image } from '@/components/Image';
import { Screen } from '@/components/Screen';
import { useResponsive } from '@/hooks/useResponsive';
import { PlaystationButton } from '@/components/PlaystationButton';
import { garamondNarrowLight } from '@/lib/fonts';
import humanResultImg from '@/img/human-result.png';
import { useOnlybotsSound } from '@/hooks/useOnlybotsSound';
import badCodeSound from '@/sounds/ob-sfx-codebox-fail.mp3';
import { BUY_URL } from '@/lib/globals';

const aspect = 246 / 345;
const IMG_SCALAR = 2.1;

interface Props {
    cancel: () => void;
}
export const HumanResult: VoidFunctionComponent<Props> = ({ cancel }) => {
    const { responsiveValue } = useResponsive();
    const { address } = useAccount();
    const [playBadCodeSound] = useOnlybotsSound(badCodeSound);

    useEffect(() => {
        playBadCodeSound();
    }, [playBadCodeSound]);

    const textProps = {
        textAlign: 'center' as const,
        font: garamondNarrowLight,
        fontSize: responsiveValue(0.35, 0.32),
        color: 'white',
        maxWidth: responsiveValue(5.1, 3.5),
        lineHeight: 1.1,
    };

    const walletAddress = address ? `${address.substring(0, 8)}...${address.substring(address.length - 2)}` : 'anon';

    return (
        <Screen>
            <Image
                position={[0, responsiveValue(1.7, 2), 0]}
                url={humanResultImg}
                scale={[aspect * IMG_SCALAR, IMG_SCALAR, 0]}
            />
            <group position={[0, -0.2, 0]}>
                <Text {...textProps}>
                    Sorry, {walletAddress}, you appear to be too human. Only bots can enter the incubator.
                </Text>
            </group>
            <group position={responsiveValue([-0.9, -1.6, 0], [-0.7, -2.1, 0])} scale={responsiveValue(1, 0.85)}>
                <PlaystationButton
                    clickableAreaDimensions={[5, 0.7]}
                    maxWidth={5}
                    position={[-1.1, 0, 0]}
                    icon="square"
                    label="ONLYBOTS MARKETPLACE"
                    action={() => {
                        window.location.href = BUY_URL;
                    }}
                />
                <PlaystationButton
                    clickableAreaDimensions={[3, 0.7]}
                    position={[0.1, -0.8, 0]}
                    icon="x"
                    label="CANCEL"
                    action={cancel}
                />
            </group>
        </Screen>
    );
};
